// Compact time-range pill buttons — used in chart panels across the app.
// Pass `size="sm"` for the smaller drawer variant (default is standard).
import { typography } from '@/shared/theme/tokens';
export function RangePicker({ ranges, value, onChange, color, c, size = 'md' }) {
  const pad    = size === 'sm' ? '2px 8px'  : '3px 10px';
  const font   = size === 'sm' ? '10px'     : '11px';
  const radius = size === 'sm' ? 5          : 6;
  const accent = color ?? c?.textActive ?? '#1e4396';

  return (
    <div style={{ display: 'flex', gap: 4 }}>
      {ranges.map((r) => {
        const active = value === r.key;
        return (
          <button
            key={r.key}
            onClick={() => onChange(r.key)}
            style={{
              padding: pad, borderRadius: radius, fontSize: font, fontWeight: active ? 700 : 500,
              border: `1px solid ${active ? accent : c?.border ?? 'rgba(0,0,0,0.12)'}`,
              background: active ? `${accent}18` : 'transparent',
              color: active ? accent : c?.textSubtle ?? '#94a3b8',
              cursor: 'pointer', fontFamily: typography.fontFamily.body,
              transition: 'all 0.12s',
            }}
          >
            {r.label}
          </button>
        );
      })}
    </div>
  );
}
